import { z } from 'zod'
import { oc } from '@orpc/contract'
import { PATIENT_INVOICE_KINDS } from '../patient-invoice-kind.contract'

/** Which patient Invoice of the encounter an action targets; co-pay unless said otherwise. */
export const patientInvoiceKindSchema = z.enum(PATIENT_INVOICE_KINDS)

// Shared boundary shape for the co-pay panel. Never a FHIR resource: only the
// fields the UI actually renders.
export const copayStatusSchema = z.object({
  configured: z.boolean(),
  /** draft = amount known from the EOB, nothing sent to the patient yet. */
  status: z.enum(['none', 'draft', 'awaiting', 'expired', 'paid', 'refunded']),
  /** Paid outside Stripe (recorded by hand): no receipt, no Stripe refund. */
  manual: z.boolean(),
  amountCents: z.number().int().optional(),
  checkoutUrl: z.string().optional(),
  receiptUrl: z.string().optional(),
  paidAt: z.string().optional(),
  refundedAt: z.string().optional(),
  linkSentTo: z.string().optional(),
  patientEmail: z.string().optional(),
  patientPhone: z.string().optional(),
  /** Card that paid (from the charge); absent for manual payments and before payment. */
  cardBrand: z.string().optional(),
  cardLast4: z.string().optional(),
  /** The ledger method of a hand-recorded payment (`manual-method` extension). */
  manualMethod: z.string().optional(),
})

export type CopayStatusResponse = z.infer<typeof copayStatusSchema>

export const encounterKindInput = z.object({
  encounterId: z.string().min(1),
  kind: patientInvoiceKindSchema.default('copay'),
})

export const getCopayStatus = oc
  .route({ method: 'GET', path: '/v2/copay/{encounterId}/status' })
  .input(encounterKindInput)
  .output(copayStatusSchema)

// Force-reconciles our Invoice with Stripe (Check status button; also the main
// path in local dev where webhooks can't reach the middleware).
export const syncCopayStatus = oc
  .route({ method: 'POST', path: '/v2/copay/{encounterId}/sync' })
  .input(encounterKindInput)
  .output(copayStatusSchema)
